import React, { useState } from 'react';
import api from '../../api/apiClient';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Input, Stack, Typography } from '@mui/joy';
import { useMask } from '@react-input/mask';
import { useTranslation } from 'react-i18next';
import cardImage from '../../images/red-card-numbered.webp';
import { handleError } from '../../utils/error-handling';

function CardDigitsPage() {
  const [digits, setDigits] = useState('');
  const { t } = useTranslation();
  const inputRef = useMask({
    mask: 'DDDD',
    replacement: {
      D: /[0-9]/,
    },
  });
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    if (!RegExp(/\d{4}/g).test(digits)) {
      handleError('error', t('cardDigitsPage.invalidDigits'));
      return;
    }

    try {
      const response = await api.post('/card/check', {
        last4Digits: digits.replaceAll(/\D/g, ''),
      });
      if (response.data.success) {
        navigate('/pin');
      } else {
        handleError(
          'error',
          response.data.tr
            ? t(`cardDigitsPage.${response.data.tr}`)
            : response.data.error
        );
      }
    } catch (e) {
      handleError(
        'error',
        e.response?.data?.tr
          ? t(`cardDigitsPage.${e.response.data.tr}`)
          : e.response?.data?.error
      );
    }
  };

  return (
    <div className="flex flex-col items-center justify-center pb-10 mb-10 pt-5">
      <Stack spacing={4}>
        <Typography level="h2" className="text-center">
          {t('cardDigitsPage.enterLast4Digits')}
        </Typography>
        <Typography level="body-lg" className="text-center italic px-4">
          {t('cardDigitsPage.instructions')}
        </Typography>
        <div className="flex justify-center">
          <img className="w-auto max-w-[300px]" src={cardImage} alt="Card" />
        </div>
        <Box component="form" onSubmit={handleSubmit} display="flex">
          <Stack
            direction="row"
            spacing={2}
            width="100%"
            justifyContent="center"
          >
            <Input
              value={digits}
              onChange={e => setDigits(e.target.value)}
              className="border p-2"
              placeholder={'1234'}
              autoFocus
              slotProps={{
                input: {
                  type: 'number',
                  ref: inputRef,
                  inputMode: 'numeric',
                  style: { direction: 'ltr' },
                },
              }}
            />
            <Button type="submit" variant="soft" color="success">
              {t('cardDigitsPage.submit')}
            </Button>
          </Stack>
        </Box>
      </Stack>
    </div>
  );
}

export default CardDigitsPage;
